module.exports = __webpack_public_path__ + "static/media/memoriesText.a34f1550.png";